module.exports = __webpack_public_path__ + "img/blueReport.a39c0251.svg";